const {Ajax, AJAX_OPTION: {PREVENT_EXECUTE}} = Mutil;

async function requestTwoFactor(props) {
    const {USER_ID, DUID, DUID_NM, AUTH_TYPE} = props;
    const deviceJson = Often.getDeviceJson(_CLIENT_IP);
    const ajaxSpace = new Ajax({packetOption: PREVENT_EXECUTE});
    try {
        if (ServerChecker.isKsfc) {
            const result = await ajaxSpace.executeApi("TWO_FACTOR_C001", {...deviceJson, USER_ID, DUID_NM, AUTH_TYPE});
            const {ERR_CD, ERR_MSG} = result;
            if ("" !== ERR_CD) {
                throw new Error(ERR_MSG);
            }
            const {OTP_TR_ID, CHALLENGE, OTP_VALUE = ""} = result;
            Mutil.setCookie("OTP_TR_ID", OTP_TR_ID);
            Mutil.setCookie("CHALLENGE", CHALLENGE);
            Mutil.setCookie("OTP_VALUE", OTP_VALUE);
        } else {
            return await ajaxSpace.executeApi("TWO_FACTOR_C001", {USER_ID, DUID, DUID_NM, AUTH_TYPE});
        }
    } catch (e) {
        Often.toast("error", e.message);
        console.error(`ERROR in requestTwoFactor : ${e}`);
    }
}

async function confirmCertNo(props) {
    const {USER_ID, DUID, AUTH_NO, AUTH_TIME_MM, OTP_TR_ID, AUTH_TYPE, CHALLENGE} = props;
    const ajaxSpace = new Ajax({packetOption: PREVENT_EXECUTE});
    try {
        return await ajaxSpace.executeApi("FLOW_AUTH_NO_CHECK_R001", {
            USER_ID,
            AUTH_NO,
            DUID,
            AUTH_TIME_MM,
            OTP_TR_ID,
            AUTH_TYPE,
            CHALLENGE
        });
    } catch (e) {
        console.error(`ERROR in confirmCertNo : ${e}`);
    }
}

async function requestPassTwoFactor(props) {
    const {USER_ID, DUID} = props;
    const ajaxSpace = new Ajax({packetOption: PREVENT_EXECUTE});
    try {
        return await ajaxSpace.executeApi("TWO_FACTOR_C002", {USER_ID, DUID});
    } catch (e) {
        console.error(`ERROR in passTwoFactor : ${e}`);
    }
}

export {requestTwoFactor, confirmCertNo, requestPassTwoFactor}